export default "__VITE_ASSET__4311587d__"